import axios from "axios";
import config from "../../../../config";
import { bffApi } from "../../../../services/bff/bffApi";
import {BaseService} from "../../../../global/classes";
import {EfeitoContratoFilterProps} from "../types";

export default class EfeitoDeContratoService extends BaseService {
  async getEffects(filter: EfeitoContratoFilterProps) {
    try {
      const merchantId = this.selectedCompany?.merchantId;
      console.log("ec",merchantId);
      const business = await this.getBusiness(merchantId);
      //console.log("ec",this.selectedCompany?.merchantId);
      console.log("BUSINESS: ", business);
      const cnpjEmpresa = business.response.records[0].cnpj;
      console.log(cnpjEmpresa);
      const cnpj = this.userInfo?.userType !== 3 ? cnpjEmpresa : (filter?.cnpj && filter.cnpj.length > 0) ? filter.cnpj : null;
      console.log(cnpj);

      const response = await bffApi.get(`/api/reg/v1/restrictionsinfo/dynamic`, {
        params: {
          settlementDate: filter.settlementDate,
          status: filter.status,
          ispb: filter.ispb,
          cnpj: cnpj
        },

      });
      return response.data;
    } catch (error) {
      console.error('Erro ao obter efeitos:', error);
      throw error;
    }
  };

  async getBusiness(merchantId: any){
    try{

      const response = await axios.get(`${config.apiBaseUrl}/payments/business`, {
        headers:{
          Authorization: `Bearer ${this.legacyAccessToken?.token}`
        },
        params: {
          offset: 0,
          pageSize: 1000,
          name: merchantId
        }
      })
      return response.data;
    } catch (e){
      console.error('Erro ao obter dados da empresa:', e);
      throw e;
    }
  }
}
